import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Herocarousel from '../container/HeroCarousel.js';
import Topicscontainer from '../container/Topicscontainer.js';
import Maintilescontainer from '../container/Maintilescontainer';
import Searchcontainer from '../container/Searchcontainer.js';
import Headercontainer from '../container/Headercontainer.js';
import Footercontainer from '../container/Footercontainer.js';
import Helpcontainer from '../container/Helpcontainer.js';
import Scrollupcontainer from '../container/Scrollupcontainer.js';
import LegalFooter from '../container/LegalFooter.js';

class HomeMainComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attachUrl: '',
    };
  }

  componentDidMount() {
    const hrefUrl = window.location.href;
    if (hrefUrl.indexOf('?locale.x') !== -1) {
      this.setState({
        attachUrl: hrefUrl.split('?')[1],
      });
    }
  }

  render() {
    const carouselInfo = JSON.parse(this.props.carouselInfo);
    const topicsInfo = JSON.parse(this.props.topicsInfo);
    const tilesInfo = JSON.parse(this.props.tilesInfo);
    const totalArticles = JSON.parse(this.props.totalArticles);
    const topicsHash = JSON.parse(this.props.topicsHash);
    const legalFooter = JSON.parse(this.props.legalFooter);
    const isPopArticleEnabled = JSON.parse(this.props.isPopArticleEnabled);
    const {
      colors,
      locale,
      country,
      isNewMppEnabled,
      isLoggedIn,
      helpContainer,
    } = this.props;

    return (
      <div className="brchome-main-component">
        <Headercontainer
          country={country}
          locale={locale}
          isLoggedIn={isLoggedIn}
          isNewMppEnabled={isNewMppEnabled}
        />
        <Herocarousel
          locale={locale}
          carouselInfo={carouselInfo}
          country={country}
        />
        <Searchcontainer country={country} />
        <div className="flex-container">
          {topicsInfo.length > 0 ? (
            <Topicscontainer
              topicsInfo={topicsInfo}
              attachUrl={this.state.attachUrl}
              isPopArticleEnabled={isPopArticleEnabled}
              locale={locale}
              country={country}
            />
          ) : (
            ''
          )}
          {totalArticles > 0 ? (
            <Maintilescontainer
              tilesInfo={tilesInfo}
              locale={locale}
              attachUrl={this.state.attachUrl}
              colors={colors}
              totalArticles={totalArticles}
              topicsHash={topicsHash}
              country={country}
            />
          ) : (
            ''
          )}
        </div>
        <Helpcontainer
          helpContainer={helpContainer}
          locale={locale}
          country={country}
        />
        <LegalFooter
          country={country}
          locale={locale}
          legalFooter={legalFooter}
        />
        <Footercontainer
          country={country}
          locale={locale}
          isNewMppEnabled={isNewMppEnabled}
        />
        <Scrollupcontainer />
      </div>
    );
  }
}

export default HomeMainComponent;

HomeMainComponent.propTypes = {
  carouselInfo: PropTypes.string,
  topicsHash: PropTypes.string,
  country: PropTypes.string,
  tilesInfo: PropTypes.string,
  colors: PropTypes.array,
  totalArticles: PropTypes.number,
  topicsInfo: PropTypes.string,
  isLoggedIn: PropTypes.string,
  isNewMppEnabled: PropTypes.string,
};
